import gql from 'graphql-tag';

export const HOME_PAGE_CAMPAIGN_FRAGMENT = gql`
  fragment homePageCampaign on HomePageCampaignType {
    campaignImage
    campaignTitle
    campaignText
    campaignButtonText
    campaignButtonUrl
  }
`;
